import React, { FC } from 'react'
import Head from 'next/head'

type Props = {
    title: string
}

export const AddSeoTitle: FC<Props> = ({ title }) => {
    return (
        <Head>
            <title>{title}</title>
        </Head>
    )
}
